<template>
  <div>
    <Header></Header>
    <nav></nav>
    <div class="Center1200">
      <div class="ConHeader">
        <h2>{{details.name || ''}}</h2>
        <span>{{details.industryTypeName || ''}}</span>
      </div>
      <div class="context">
        <p>企业简介</p>
        <span v-html="details.info"></span>
        <p>联系方式</p>
        <span>联系人：{{details.contact}}</span>
        <span>联系方式：{{details.contactNum}}</span>
        <span>在京办公地址：{{details.address}}</span>
        <p>主要业务</p>
        <span v-html="details.business"></span>
        <p>典型案例</p>
        <span v-html="details.typical"></span>
      </div>
      <el-button @click="Back()">返回</el-button>
    </div>
  </div>
</template>
<script>
import {infoApi} from "@/api/ent2/EntInfo";
import Header from '@/components/header.vue';

export default {
  name: "EntInfo",
  components:{
    Header
  },
  data() {
    return{
      details:{}
    }
  },
  created() {
    infoApi({
      params:{
        entId:this.$route.query.id
      }
    }).then((res) => {//获取详情
      this.details = res.data.data;
    });
  },
  methods:{
    Back(){
      this.$router.go(-1)
    }
  }
}



</script>

<style scoped>
  nav{
    height: 60px !important;
    background: #BA0132;
  }
  .Center1200{
    width: 1170px;
    padding: 0px 15px;
    margin: 0 auto;
  }
  .ConHeader{
    height: 40px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgb(215,215,215);
  }
  .ConHeader>h2{
    margin: 0px 44px;
  }
  .ConHeader span{
    font-size: 14px;
    color: rgb(249,177,144);
    background: rgb(253,240,220);
    padding:3px 8px;
    border-radius: 5px;
  }
  .context{
    text-align: left;
    font-size: 14px;
  }
  .context p{
    color: #A30014;
    margin: 30px 0px;
    font-size: 16px;
  }
  .context span{
    display: block;
    text-indent: 2em;
    margin-bottom: 15px;
    line-height: 28px;
  }
</style>
